import { useMemo } from 'react';
import { extent } from 'd3-array';
import type { PortfolioPerformanceTimeseries } from '@/hooks/portfolio/usePortfolioPerformanceTimeseries';
import { normaliseData } from '../../utils';

type Args = {
  timeseries: PortfolioPerformanceTimeseries;
};

export const useChartData = ({ timeseries }: Args) => {
  const { normalisedPerformanceTimeseriesData } = useMemo(
    () => ({
      normalisedPerformanceTimeseriesData: normaliseData(timeseries),
    }),
    [timeseries]
  );

  const { xExtent, yExtent } = useMemo(() => {
    const dateData = normalisedPerformanceTimeseriesData.map((n) =>
      n[0].getTime()
    );
    const valueData = normalisedPerformanceTimeseriesData.map((n) => n[1]);

    return { xExtent: extent(dateData), yExtent: extent(valueData) };
  }, [normalisedPerformanceTimeseriesData]);

  const [xMin, xMax] = xExtent;
  const [yMin, yMax] = yExtent;

  return {
    normalisedPerformanceTimeseriesData,
    xDomain: [xMin || 0, xMax || 0],
    yDomain: [yMin || 0, yMax || 0],
  };
};
